import React from 'react';
import {auth} from '../fire';
import provider from '../fire';
import google from '../Log-in/Im/google.png'
import {useAuthState} from 'react-firebase-hooks/auth';
import '../Log-in/Log.css';
import { signInWithGoogle } from '../fire';
import firebase from '@firebase/app-compat';


class Googlelogin extends React.Component {

  constructor() {
    super();

    this.state = {
      currentUser: null
    };
  }

  unsubscribeFromAuth = null;

  componentDidMount() {
    this.unsubscribeFromAuth = auth.onAuthStateChanged(user => {
      this.setState({ currentUser: user });
    });
  }

  componentWillUnmount() {
    this.unsubscribeFromAuth();
  }

  render() {
    return (
      <div className='user-info'>
        {

          this.state.currentUser ?

            (<div>
              <div>
                <img src={this.state.currentUser.photoURL} />
              </div>
              <div>Name: {this.state.currentUser.displayName}</div>
              <div>Email: {this.state.currentUser.email}</div>

              <button onClick={() => auth.signOut()}>LOG OUT</button>
            </div>
            ) :

            <div className="google-login-ct"> <button className="google-logo" onClick={() => signInWithGoogle().then(res => 
              {
                 console.log('google login succesfull', res)
                 const allUsers = firebase.firestore().collection('users').get().then(response => {
                   console.log('all users from db', response.docs)
                   if (response.docs.findIndex(value => value.data().uid == res.user.uid) == -1) {
                    const addUserToDB = firebase.firestore().collection('users').add({
                      'name': res.user.displayName,
                      'phone': res.user.phoneNumber,
                      'email': res.user.email,
                      'uid': res.user.uid
                    }).then(response => {
                      console.log('User added to db', response)
                    }).catch(error => {
                      console.log('User not added to db', error)
                    })
                   } else {
                     console.log('user is already stored on db');
                   }
                 })
                }).catch(error => {
                  console.log('Google login fail', error)
                })
              }><img className="google" src={google} alt="Logo" /> login with google</button></div>
          

        }
      </div >
    );
  }
}


export default Googlelogin;
